export default __webpack_public_path__ + "static/media/Grips of the Howling Giant.604d5a8e.jpg";